/* global VK */
/* global gtag */
/* global yaCounter38825985 */

import Vue
  from 'vue';
import Vuex
  from 'vuex';

import { get, post } from '@shared/transforming-keys-axios';

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    loaded: false,
    authenticated: null,
    submitted: false,
    submitting: false,
    userName: null,
    userEmail: null,
    userPhone: null,
    userLeadId: null,
    interestType: null,
    interestId: null,
    interestOptions: null,
    submitUrl: null,
    redirectUrl: null,
    payment: null,
    registrationClosed: false,
    registrationClosesAt: null,
    resourcesUrl: null,
    afterSubmittedUrl: null,
    oauthProvider: null,
    showOauthIcons: true,

    webinarSpecifics: null,
  },

  getters: {
    interestIs: ({ interestType }) => (checkValue) => interestType === checkValue,
  },

  mutations: {
    initialize (state, { authenticated, userName, userPhone, userEmail, interestType, interestId, interestOptions, submitted, submitUrl, payment, registrationClosed, registrationClosesAt, resourcesUrl, afterSubmittedUrl, afterSubmittedPaid, webinarSpecifics }) {
      state.authenticated = authenticated;
      state.userName = userName;
      state.userPhone = userPhone;
      state.userEmail = userEmail;
      state.interestType = interestType;
      state.interestId = interestId;
      state.interestOptions = interestOptions;
      state.submitted = submitted;
      state.submitUrl = submitUrl;
      state.payment = payment;
      state.registrationClosed = registrationClosed;
      state.registrationClosesAt = registrationClosesAt;
      state.resourcesUrl = resourcesUrl;
      state.afterSubmittedUrl = afterSubmittedUrl;
      state.afterSubmittedPaid = afterSubmittedPaid;
      state.webinarSpecifics = webinarSpecifics;

      state.loaded = true;
    },

    setLoaded (state, newValue = true) {
      state.loaded = newValue;
    },

    setSubmitted (state, newValue = true) {
      state.submitted = newValue;
    },

    setSubmitting (state, newValue = true) {
      state.submitting = newValue;
    },

    pseudoLogout (state) {
      state.authenticated = false;
      state.userName = '';
      state.userEmail = '';
      state.userPhone = '';
      state.oauthProvider = null;
      state.userLeadId = null;
      state.showOauthIcons = false;
    },

    setLeadData (state, { name, email, phone, lead_id: leadId }) {
      state.userName = name;
      state.userEmail = email;
      state.userPhone = phone;
      state.userLeadId = leadId;
    },

    setRedirectUrl (state, value) {
      state.redirectUrl = value;
    },

    setOauthProvider (state, value) {
      state.oauthProvider = value;
    },
  },

  actions: {
    initialize ({ commit }, { delay = 0 } = {}) {
      commit('setLoaded', false);

      setTimeout(() => {
        get(window.location.href).then(({ data }) => {
          commit('initialize', data);
        });
      }, delay);
    },

    setLeadData ({ commit }, { leadData, delay = 0 }) {
      commit('setLoaded', false);

      setTimeout(() => {
        commit('setLeadData', leadData);
        commit('setLoaded', true);
      }, delay);
    },

    submit ({ commit, state }, { email, name, phone, gdprConfirmed, newsletter, recaptchaResponse, interestId, interestType, interestOptions }) {
      commit('setSubmitting', true);

      const { userLeadId } = state;

      post(state.submitUrl, {
        user: {
          email, name, phone,
          interestId,
          interestType,
          interestOptions,
          leadId: userLeadId,
          userSettingAttributes: {
            newsletter,
            gdprConfirmed,
          },
        },
        'g-recaptcha-response': recaptchaResponse,
      }).then(({ data }) => {
        commit('setSubmitted', true);
        commit('setRedirectUrl', data);
      }).then(() => {
        if (window.VK)
          VK.Retargeting.Event('form-successfully-submitted');

        if (window.gtag)
          gtag('event', 'submit', {
            event_category: 'forms',
            event_label: 'training',
          });

        if (window.yaCounter38825985)
          yaCounter38825985.reachGoal('training');
      }).finally(() => {
        commit('setSubmitting', false);
      });
    },
  },
});

window.vueStore = store;

export default store;
